<template lang="pug">
  section
    s-page-title(
      :previous='true'
      :title='id ? "Редактирование товара" : "Добавление товара"'
    )
    v-card
      v-container(grid-list-xl fluid)
        v-layout(wrap)
          v-flex(xs12)
            s-publish-date-status(
              :errors='errors'
              :model='item'
              label='Товар опубликован'
            )
          v-flex(xs12)
            v-text-field(
              :error='errors.has("name")'
              :error-messages='errors.first("name")'
              v-model='item.name'
              label='Название товара'
            )
          v-flex(xs6)
            v-text-field(
              :error='errors.has("actual_price")'
              :error-messages='errors.first("actual_price")'
              v-model='item.actual_price'
              label='Актуальная цена'
              type="number"
            )
          v-flex(xs6)
            v-text-field(
              :error='errors.has("new_price")'
              :error-messages='errors.first("new_price")'
              v-model='item.new_price'
              label='Старая цена (для акций, показать на удешевление)'
              type="number"
            )            
          v-flex(xs12)
            v-select(
              v-if='attributes'
              :error='errors.has("categories")'
              :error-messages='errors.first("categories")'
              :items='attributes.categories'
              item-text='name'
              item-value='id'
              v-model='item.categories'
              label='Категории'
              multiple
              chips
            )
          v-flex(xs12)
            v-textarea(
              :error='errors.has("annotation")'
              :error-messages='errors.first("annotation")'
              v-model='item.annotation'
              label='Краткое описание'
            )
          v-flex(xs12)
            s-slug-input(
              :model='item'
            )
          v-flex(v-if="editor" xs12)
            div(class='subheading font-weight-medium mb-3') Описание товара
            ckeditor(v-model='item.description')
          v-flex(xs12)
            v-text-field(
              :error='errors.has("meta_title")'
              :error-messages='errors.first("meta_title")'
              v-model='item.meta_title'
              label='META title'
            )
          v-flex(xs12)
            v-textarea(
              :error='errors.has("meta_description")'
              :error-messages='errors.first("meta_description")'
              v-model='item.meta_description'
              label='META description'
            )            
          v-flex(xs4)
            s-image-upload(
              :src='item.avatar_url'
              v-model='item.avatar'
              ratio='auto'
              label='Основная картинка товара'
            )
          v-flex(xs12)
            s-sortable(
              @change='onFilesSort'
              @remove='onFileRemove'
              :sortable='item.files'
              :openable='true'
              :deletable='true'
            )
          v-flex(xs12)
            dropzone(
              v-model='files'
              @error='$root.showSnack("Ошибка загрузки файла")'
            )
      v-card-actions(class='large')
        v-spacer
        s-back-btn
        v-btn(
          @click='onSave'
          :loading='isLoading'
          color='primary'
          depressed
        ) Сохранить
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import http from "@/http";

export default {
  props: ['id'],

  components: {
    Ckeditor: () => import('@/components/async/Ckeditor'),
    Dropzone: () => import('@/components/async/Dropzone')
  },

  data: () => ({
    item: {},
    files: {},
    editor: true,
    attributes: {}
  }),

  async created() {
    this.fetchAttributes()
    if (this.id===undefined) return
    this.updateItem()
  },

  methods: {
    async updateItem() {
      this.item = (await this.fetchSingle({ id: this.id })).data
      this.item.categories = this.item.categories.map((item)=> +item)
    },

    async fetchAttributes() {
      try {
        const res = await http.get('/shop/goods/attributes')
        this.attributes = res.data
      } catch(error) {
        this.$root.showSnack('Ошибка загрузки атрибутов')
      }
    },

    async onSave() {
      let data = this.item
      data.uploaded_files = Object.keys(this.files)


      try {
        if (this.id) {
          await this.update({ id: this.id, data })
        } else {
          await this.create({ data })
        }
        this.$root.showSnack('Товар сохранен')
        this.$router.push({ name: 'Shop.Goods' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    async onFilesSort(files) {
      if (!this.isLoading) {
        try {
          await this.sortFiles(files.map(x => x.hash))
        } catch (e) {
          this.$root.showSnack('Ошибка сортировки файлов')
        }
      }
    },

    async onFileRemove({ hash }) {
      if (!this.isLoading && (await this.$confirm('Вы уверены?'))) {
        try {
          await this.removeFile(hash)
          this.updateItem()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления файла')
        }
      }
    },

    ...mapActions('shop/goods', [
      'fetchSingle',
      'update',
      'create',
      'removeFile',
      'sortFiles'
    ])
  },

  computed: {
    ...mapGetters('shop/goods', ['isLoading'])
  }
}
</script>

<style>
.small textarea {
  font-size: 12px;
}
</style>
